module.exports = __webpack_public_path__ + "static/vasu-9392296d61b1dc468deba5b154fbe215.png";